export const RewardsRateTypeToUnit: Record<string, string> = {
  cash: '%',
  points: 'x',
  miles: 'x',
};

export const offersPromotionalCopies: Record<string, string> = {};

export const aprDriverEmptyValueString = 'N/A';

export const AMEX_INSTITUTION_ID = 'cd471c3b-eca7-487c-9a41-ed802b938fca';

export const IMAGE_WIDTH = 150;
